var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatarForChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#819F97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9467 14.4744C14.005 14.4743 15.1054 11.3988 15.3935 8.8725C15.7483 5.76026 14.2831 3.41797 10.9467 3.41797C7.61082 3.41797 6.14476 5.76009 6.49989 8.87247C6.78829 11.3987 7.88831 14.4747 10.9467 14.4744Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2195 21.7976C19.186 20.8173 19.0716 19.8325 18.9013 18.8674C18.6949 17.6984 18.4323 15.9844 17.416 15.2226C16.8283 14.7821 16.0672 14.6375 15.3944 14.3719C15.0669 14.2427 14.7735 14.1143 14.4982 13.9683C13.5689 14.9917 12.3572 15.5271 10.9461 15.5272C9.53537 15.5272 8.32377 14.9918 7.39459 13.9683C7.11927 14.1144 6.82591 14.2428 6.49844 14.3719C5.82561 14.6375 5.06453 14.782 4.47687 15.2226C3.46053 15.9844 3.1979 17.6984 2.99156 18.8674C2.82119 19.8325 2.70678 20.8173 2.67338 21.7976C2.64751 22.5569 3.02081 22.6633 3.65328 22.8926C4.44529 23.1795 5.26296 23.3924 6.08611 23.567C7.6759 23.9042 9.31462 24.1633 10.9463 24.1749C12.578 24.1633 14.2167 23.9042 15.8065 23.567C16.6297 23.3925 17.4474 23.1795 18.2393 22.8926C18.8721 22.6634 19.2453 22.557 19.2195 21.7976Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatarForChat);
export default __webpack_public_path__ + "static/media/default_avatar_for_chat.66e676870ac05d166c42fc037d655141.svg";
export { ForwardRef as ReactComponent };